import { Injectable } from '@angular/core';
import { ConfigBaseFilter, ListLayout, ListLayoutMultipleComponent } from 'gung-list';
import { Order, QuotesConfigService } from 'gung-standard';
import { OrderDateFilter } from 'gung-standard-jeeves';
import { SjoborgQuotesTableComponent } from '../components/sjoborg-quotes-table/sjoborg-quotes-table.component';

@Injectable({
  providedIn: 'root'
})
export class SjoborgQuotesConfigService extends QuotesConfigService {
  getLayouts(): ListLayout<Order>[] {
    return [
      {
        getIconClass: () => '',
        getListItemComponent: () => SjoborgQuotesTableComponent,
        getListLayoutComponent: () => ListLayoutMultipleComponent,
        getName: () => 'Order list'
      }
    ];
  }

  getFilters(): ConfigBaseFilter<Order>[] {
    return [new OrderDateFilter()];
  }

  getSearchTerms(item: Order): string[] {
    return [item.id, item.extra.oh.kundref2, item.extra.oh.kundbestnr];
  }
}
